import {
    HiddenPanelAction,
    HiddenPanelActionType,
} from "../../Controls/FormParts/HiddenPanel/Store/HiddenPanelActions";
import { isPanelTypeChangeManually, PanelTabType, PanelType } from "../../Controls/FormParts/Panel/PanelTypes";
import { CandyThunkAction } from "../Core/Store/CandyReduxTypes";
import { getDraftFullId, getFormRootModelPath } from "../../Forms/Types/FormSettings";

import { setToModel } from "./AllActionCreators";
import { savePanelStateToLocalStorage } from "./PanelTypeStroing";

export function setPanelState(panelState: PanelType): CandyThunkAction {
    return (d, s) => {
        if (isPanelTypeChangeManually(panelState)) {
            savePanelStateToLocalStorage(getDraftFullId(s().settings), panelState);
        }
        d({ type: HiddenPanelActionType.SetPanelState, payload: panelState });
    };
}

export function setPanelActiveTab(panelState: PanelTabType): HiddenPanelAction {
    return { type: HiddenPanelActionType.SetPanelActiveTab, payload: panelState };
}

export function setWidePanel(isWidePanel: boolean): HiddenPanelAction {
    return { type: HiddenPanelActionType.SetWidePanel, payload: isWidePanel };
}

export function setPopupPanel(isPopupPanel: boolean, isFrozenPopup?: boolean): HiddenPanelAction {
    return {
        type: HiddenPanelActionType.SetPopupPanel,
        payload: { isPopupPanel: isPopupPanel, isFrozenPopup: isFrozenPopup },
    };
}

export function frozenPanel(isFrozenPanel: boolean): HiddenPanelAction {
    return { type: HiddenPanelActionType.FrozenPanel, payload: isFrozenPanel };
}

export function setEmptyUnitsVisible(isVisible: boolean): CandyThunkAction {
    return (dispatch, _, form) =>
        dispatch(setToModel(getFormRootModelPath(form.settings), "emptyUnitsVisible", isVisible));
}
